import { render } from "./gooey-preloader.vue?vue&type=template&id=05ccbf49&scoped=true&bindings={\"type\":\"props\"}"
import script from "./gooey-preloader.vue?vue&type=script&lang=js"
export * from "./gooey-preloader.vue?vue&type=script&lang=js"

import "./gooey-preloader.vue?vue&type=style&index=0&id=05ccbf49&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05ccbf49"

export default script